/*
 * Copyright (c) 2021
 * Company: G-Portal
 * Filename: translation.ts
 * Class: translation.ts
 * Author: Karl Magerl<karl@g-portal.com>
 * Version:
 */

import i18next from 'i18next';
import HttpBackend from 'i18next-http-backend';

const defaultNamespace: string = 'general';

const namespaces = (): string[] => {
  return [
    'general',
    'payment',
    'landingpage',
    'gameserver',
    'donation',
    'dashboard',
    'checkout',
    'configuration',
    'footer',
    'modal',
    'profile',
    'stepthree',
    'stepfour',
    'pending'
  ];
};

export const initI18n = (mode: string, language: string = 'de') => {

  if (i18next.isInitialized) {
    throw new Error('i18next is already initialized, skipping init');
  }

  console.time('i18next-init');
  return new Promise((resolve, reject) => {
    i18next
      .use(HttpBackend)
      .init({
        lng: language,
        debug: true,
        fallbackLng: false,
        load: 'languageOnly',
        lowerCaseLng: true,
        returnEmptyString: false,
        ns: namespaces(),
        defaultNS: defaultNamespace,
        backend: {
          loadPath: `${process.env.VUE_APP_CDN_I18N_URL}/${mode}/{{lng}}/{{ns}}.json`
        },
        initImmediate: false,
        keySeparator: false,
        appendNamespaceToMissingKey: true
      }, (err) => {
        console.timeEnd('i18next-init');
        if (err != null) reject(err);
        resolve(null);
      });
  });
}

let debug = false;
if (process.env.NODE_ENV === 'development') {
  window.onkeydown = (event) => {
    if (event.key === 'Control') {
      debug = true;
    }
  }
}

// proxy for more functionality
i18next.t = (function (proxy) {
  return function (...args) {
    if (debug === true && process.env.NODE_ENV === 'development') {
      return `${args[0]} => `.concat(proxy.apply(this, args));
    }
    return proxy.apply(this, args);
  }
})(i18next.t)

// --- production until fallback has been developed
initI18n(process.env.VUE_APP_I18N_MODE || 'production', window.customerLanguageCode);
